interface CalendarDueIconProps {
    size?: number;
    color?: string;
}

/** Calendar with a downward marker — used for activity due dates. */
export function CalendarDueIcon({
    size = 22,
    color = "currentColor",
}: CalendarDueIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.66666 7.3335H18.3333M3.66666 7.3335V15.4003C3.66666 16.4271 3.66666 16.9402 3.86648 17.3324C4.04225 17.6774 4.32251 17.9581 4.66747 18.1339C5.05926 18.3335 5.5724 18.3335 6.59716 18.3335H15.4033C16.428 18.3335 16.9404 18.3335 17.3322 18.1339C17.6772 17.9581 17.9579 17.6774 18.1337 17.3324C18.3333 16.9406 18.3333 16.4282 18.3333 15.4034V7.3335M3.66666 7.3335V6.60034C3.66666 5.57358 3.66666 5.05981 3.86648 4.66764C4.04225 4.32268 4.32251 4.04242 4.66747 3.86665C5.05964 3.66683 5.57341 3.66683 6.60017 3.66683H7.33332M18.3333 7.3335V6.59733C18.3333 5.57257 18.3333 5.05943 18.1337 4.66764C17.9579 4.32268 17.6772 4.04242 17.3322 3.86665C16.94 3.66683 16.4269 3.66683 15.4002 3.66683H14.6667M7.33332 3.66683H14.6667M7.33332 3.66683V1.8335M14.6667 3.66683V1.8335M12.8333 14.6668L11 12.8335M11 12.8335L9.16666 11.0002M11 12.8335L12.8333 11.0002M11 12.8335L9.16666 14.6668"
                stroke={color}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
